import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "Marketing_Video",
  class: "dashboard-card d-flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Axxess Central")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "video-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "empty-state text-center text-default w-100 p-5",
  else: ""
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fst-italic" }, " You do not have permission to view this data. Contact an administrator at your agency to request access. ")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_CardTemplate = _resolveComponent("CardTemplate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardTemplate, null, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createElementVNode("section", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default"),
          (_ctx.isError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.isAuthorized)
                  ? (_openBlock(), _createBlock(_component_ErrorMessageHandler, {
                      key: 0,
                      title: _ctx.title ? _ctx.title : 'the data'
                    }, null, 8 /* PROPS */, ["title"]))
                  : _createCommentVNode("v-if", true),
                _hoisted_5
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 3 /* FORWARDED */
    })
  ]))
}